// extracted by mini-css-extract-plugin
export default {"drawer":"styles_drawer__eBbzO","open":"styles_open__jVEUd","drawer-content":"styles_drawer-content__PhVrx","closeButton":"styles_closeButton__3tmav"};